export enum LanguagesTypes {
    GET_LIST = '@languages/GET_LIST',
    REQUEST_GET_LIST = '@languages/REQUEST_GET_LIST',
}

export type Language = {
    code: string;
    name: string;
};

export type LanguagesState = {
    isLoading: boolean;
    languages: Language[];
};

export type LanguagesAction<Payload> = {
    type: LanguagesTypes;
    payload: Payload;
};

export type AuthReducer = (state: LanguagesState, actions: LanguagesAction<LanguagesState>) => LanguagesState;
